.page {
  background-color: var(--pgm-sys-color-surface-container);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.topbar {
  align-items: center;
  background-color: var(--pgm-sys-color-surface-container);
  box-sizing: border-box;
  color: var(--pgm-sys-color-on-surface);
  display: flex;
  gap: var(--pgm-sys-spacing-4);
  justify-content: space-between;
  min-height: 64px;
  padding: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-6);
  position: sticky;
  top: 0;
  z-index: 1;
}

.brand {
  align-items: center;
  display: flex;
  gap: var(--pgm-sys-spacing-3);
}

.brandIcon {
  color: var(--pgm-sys-color-primary);
}

.navigationToggle {
  display: none;
}

.accountMenu {
  min-width: 0;
  position: relative;
}

.accountToggle {
  align-items: center;
  background: none;
  border: 0;
  border-radius: 20px;
  color: var(--pgm-sys-color-on-surface-variant);
  cursor: pointer;
  display: flex;
  gap: var(--pgm-sys-spacing-2);
  max-width: 100%;
  min-height: 40px;
  padding: 0 var(--pgm-sys-spacing-2) 0 var(--pgm-sys-spacing-3);
}

.accountToggle:hover {
  background-color: color-mix(in srgb, var(--pgm-sys-color-on-surface) 8%, transparent);
}

.accountToggle:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: 2px;
}

.accountToggle:disabled {
  cursor: default;
  opacity: 0.38;
}

.accountChevron {
  margin-left: calc(-1 * var(--pgm-sys-spacing-1));
}

.userName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu {
  background-color: var(--pgm-sys-color-surface-container);
  border-radius: 4px;
  box-shadow: 0 2px 6px 2px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  min-width: 200px;
  padding: var(--pgm-sys-spacing-2) 0;
  position: absolute;
  right: 0;
  top: calc(100% + var(--pgm-sys-spacing-1));
  z-index: 3;
}

.menuItem {
  align-items: center;
  background: none;
  border: 0;
  color: var(--pgm-sys-color-on-surface);
  cursor: pointer;
  display: flex;
  gap: var(--pgm-sys-spacing-3);
  min-height: 48px;
  padding: 0 var(--pgm-sys-spacing-3);
  text-align: left;
}

.menuItem :global(.material-symbols-sharp) {
  color: var(--pgm-sys-color-on-surface-variant);
}

.menuItem:hover,
.menuItem:focus-visible {
  background-color: color-mix(in srgb, var(--pgm-sys-color-on-surface) 8%, transparent);
  outline: none;
}

.passwordForm {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
}

.passwordIntro {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0 0 var(--pgm-sys-spacing-2);
}

.passwordField {
  min-height: 80px;
  min-width: 0;
}

.passwordError {
  color: var(--pgm-sys-color-error);
  margin: 0;
}

.body {
  align-items: flex-start;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  gap: var(--pgm-sys-spacing-6);
  padding: 0 var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-2);
}

.sidebar {
  box-sizing: border-box;
  flex: 0 0 264px;
  min-width: 0;
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-6) 0;
  position: sticky;
  top: 64px;
}

.sidebarHeader {
  display: none;
}

.scrim {
  display: none;
}

.content {
  align-self: stretch;
  background-color: var(--pgm-sys-color-surface);
  border-radius: 20px;
  box-sizing: border-box;
  flex: 1 1 auto;
  min-width: 0;
  padding: var(--pgm-sys-spacing-10);
}

.contentPlain {
  background-color: transparent;
  border-radius: 0;
  padding: 0;
}

.status {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
  padding: var(--pgm-sys-spacing-10) var(--pgm-sys-spacing-6);
}

@media (max-width: 839.98px) {
  .navigationToggle {
    display: inline-flex;
  }

  .body {
    padding: 0 var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-4);
  }

  .sidebar {
    background-color: var(--pgm-sys-color-surface-container);
    border-radius: 0 16px 16px 0;
    bottom: 0;
    left: 0;
    overflow-y: auto;
    padding: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-6);
    position: fixed;
    top: 0;
    transform: translateX(-100%);
    transition: transform 0.2s ease, visibility 0.2s;
    visibility: hidden;
    width: 300px;
    max-width: calc(100vw - 56px);
    z-index: 3;
  }

  .sidebarOpen {
    transform: translateX(0);
    visibility: visible;
  }

  .sidebarHeader {
    display: flex;
    margin-bottom: var(--pgm-sys-spacing-3);
    min-height: 48px;
    align-items: center;
  }

  .scrim {
    background-color: var(--pgm-sys-color-scrim);
    display: block;
    inset: 0;
    opacity: 0.32;
    position: fixed;
    z-index: 2;
  }

  .content {
    padding: var(--pgm-sys-spacing-6);
  }

  .contentPlain {
    padding: 0;
  }
}

@media (max-width: 599.98px) {
  .topbar {
    padding: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-4);
  }

  .userName {
    display: none;
  }

  .content {
    padding: var(--pgm-sys-spacing-4);
  }

  .contentPlain {
    padding: 0;
  }
}
